var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopupEnabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8ZM6 5C5.86739 5 5.74022 5.05268 5.64645 5.14645C5.55268 5.24021 5.5 5.36739 5.5 5.5C5.5 5.63261 5.55268 5.75979 5.64645 5.85355C5.74022 5.94732 5.86739 6 6 6H7.5V10.8333C7.5 10.9659 7.55268 11.0931 7.64645 11.1869C7.74022 11.2807 7.86739 11.3333 8 11.3333C8.13261 11.3333 8.25979 11.2807 8.35355 11.1869C8.44732 11.0931 8.5 10.9659 8.5 10.8333V6H10C10.1326 6 10.2598 5.94732 10.3536 5.85355C10.4473 5.75979 10.5 5.63261 10.5 5.5C10.5 5.36739 10.4473 5.24021 10.3536 5.14645C10.2598 5.05268 10.1326 5 10 5H6Z",
    fill: "#1B51A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopupEnabledIcon);
export default __webpack_public_path__ + "static/media/topup_enabled_icon.46756caff1adc8b000d18738547f4708.svg";
export { ForwardRef as ReactComponent };